exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#example_import[data-v-7b73434f] {\r\n    height: 300px;\r\n    overflow: auto;\n}\r\n", ""]);

// exports
